/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenGenericIcon32Regular = forwardRef('TechScreenGenericIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 3A5.5 5.5 0 0 0 2 8.5v11A5.5 5.5 0 0 0 7.5 25h17a5.5 5.5 0 0 0 5.5-5.5v-11A5.5 5.5 0 0 0 24.5 3h-17ZM4 8.5A3.5 3.5 0 0 1 7.5 5h17A3.5 3.5 0 0 1 28 8.5v11a3.5 3.5 0 0 1-3.5 3.5h-17A3.5 3.5 0 0 1 4 19.5v-11Z" }),
        React.createElement("path", { d: "M8 27a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H8Z" })));
});
